import Vue from 'vue'

// 文件名称字数限制
Vue.filter('limitFileName', function (val, length, isFile = '') {
    if (!val) return
    let nameLength = val.lastIndexOf('.')
    let fileName = val.substring(0, nameLength)
    let fileType = val.substring(nameLength, val.length)
    if (isFile) { //文件夹
        if(val.length <= length){
            return val
        }else{
            return val.substring(0, length) + '...'
        }
    } else {
        if (fileName.length <= length) {
            return val
        } else {
            return fileName.substring(0, length - 1) + "..." + fileName.substring(fileName.length - 1, fileName.length) + fileType
        }
    }
})



// WEBPACK FOOTER //
// ./src/comm/utils/filters.js